import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, ITrainingScenarioPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';

const TrainingScenarioPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: trainingScenario,
    loading,
    error,
  } = useObjectPreview<ITrainingScenarioPreviewJson>(id, INamedObjectTypes.TrainingScenario);
  if (error) return <span>Sorry, there was an error.</span>;
  if (loading) return <Spinner />;
  return (
    <div className="trainingscenario-preview">
      <style jsx>{`
        .trainingscenario-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .trainingscenario-preview__thing-list > div {
          display: flex;
        }

        .trainingscenario-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      {trainingScenario && (
        <>
          <div className="trainingscenario-preview__body">
            <div className="trainingscenario-preview__thing-list">
              <div>
                <strong>Lookup</strong>
                <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
                  {id}{' '}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Name</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${trainingScenario.name}`}
                >
                  {trainingScenario.name}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Project</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${trainingScenario.project}`}
                >
                  {trainingScenario.project}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Status</strong>
                {trainingScenario.status}
              </div>
              <div>
                <strong>Training Type</strong>
                {trainingScenario.trainingType}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TrainingScenarioPreview;
